import * as React from 'react'
import { colours } from '../../../config/theme'
import IconType from '../../../general/Icon/iconTypes'
import ModuleCard from './ModuleCard'

export const CarePlansModuleCard = () => (
  <ModuleCard
    backgroundColor={colours.status.popout}
    icon={IconType.CarePlansHexagon}
    link="/"
    linkText="Find out more"
    subtitle="Create personalised care and support plans using our easy-to-use templates."
    title="Support Plans"
    onClick={() =>
      window.open('https://logmycare.co.uk/features/care-delivery#care_plans')
    }
  />
)
